import React from 'react';
import { ClusterPageTemplate } from '../components/ClusterPageTemplate';
export function ClusterFysiotherapiePage() {
  return <ClusterPageTemplate clusterName="Fysiotherapie" sectorName="Zorgpraktijken" sectorSlug="zorgpraktijken" heroTitle="Website laten maken voor een fysiotherapiepraktijk" heroDescription="Een professionele, toegankelijke website voor jouw fysiopraktijk. Wij bouwen websites die patiënten aantrekken en de druk op de receptie verlagen." websiteOnderdelen={[{
    icon: 'HeartPulseIcon',
    title: 'Specialisaties',
    description: "Heldere pagina's voor manuele therapie, sportfysio, dry needling en andere specialisaties."
  }, {
    icon: 'UsersIcon',
    title: 'Het Team',
    description: 'Stel de therapeuten voor met hun specialisaties en BIG-registraties om direct vertrouwen te wekken.'
  }, {
    icon: 'CalendarCheckIcon',
    title: 'Afspraak maken',
    description: 'Een duidelijke flow voor nieuwe en bestaande patiënten om online een behandeling in te plannen.'
  }, {
    icon: 'FileTextIcon',
    title: 'Patiënteninformatie',
    description: 'Informatie over tarieven, vergoedingen, contracten met zorgverzekeraars en de eerste afspraak.'
  }]} functionaliteiten={[{
    icon: 'CalendarCheckIcon',
    title: 'Patiëntenportaal koppeling',
    description: 'Naadloze integratie met systemen zoals Intramed, SpotOnMedics of FysioRoadmap.'
  }, {
    icon: 'SearchIcon',
    title: 'Lokale SEO',
    description: "Zorg dat je praktijk bovenaan staat wanneer mensen zoeken naar 'fysio [jouw wijk/stad]'."
  }, {
    icon: 'ShieldCheckIcon',
    title: 'AVG-proof formulieren',
    description: 'Veilige contactformulieren die voldoen aan de strenge privacy-eisen in de zorg.'
  }]} siblingClusters={[{
    name: 'Tandarts',
    slug: 'tandarts'
  }, {
    name: 'Huisarts',
    slug: 'huisarts'
  }, {
    name: 'Psycholoog',
    slug: 'psycholoog'
  }]} faqs={[{
    q: 'Kunnen jullie koppelen met Intramed of SpotOnMedics?',
    a: 'Ja, we kunnen de online afspraakmodules van de bekende EPD-systemen (zoals Intramed, SpotOnMedics, FysioRoadmap) integreren in de website.'
  }, {
    q: 'Wat kost een website voor een fysiotherapiepraktijk?',
    a: "Een professionele praktijkwebsite start vanaf €1.500. De prijs is afhankelijk van het aantal specialisatie-pagina's dat we voor je schrijven en inrichten."
  }, {
    q: 'Hoe zorg ik voor meer patiënten voor een specifieke behandeling?',
    a: "We maken aparte, SEO-geoptimaliseerde landingspagina's voor specifieke behandelingen (bijv. 'Dry Needling Alkmaar') zodat je daar lokaal goed op gevonden wordt."
  }, {
    q: 'Voldoet de website aan de AVG-wetgeving?',
    a: 'Ja, we zorgen voor een SSL-certificaat, cookie-melding en richten formulieren zo in dat ze voldoen aan de richtlijnen voor het verwerken van medische gegevens.'
  }]} data-id="element-1072" data-mp="mpb4y4k2im76" />;
}